export const REGEX = {
  PERSON_TEXT_RU: /^[а-яёА-ЯЁ \-–—]{2,}$/u,
  PERSON_TEXT_COM: /^(?!.*https?)[A-Za-zА-Яа-яЁё \-–—]{2,}$/u,
  ONLY_CHAR: /^[A-Za-zА-Яа-яЁё]{2,}$/u,
  MAIL: /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
  MAIL_WITH_RU: /^(?:[+a-z0-9._-]+|[+а-яё0-9._-]+)@(?:[a-z0-9.-]+\.[a-z]{2,}|[а-яё0-9.-]+\.рф)$/iu,
  LINK: /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(\:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i,
  NUMBER: /^(\d)+$/,
  STRING_FROM_2_SYMBOLS: /\S{2,}/i,
}



// WEBPACK FOOTER //
// ./src/modules/shared/const/regex.const.js